import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import Table from '@editorjs/table';
import Underline from '@editorjs/underline';
import Paragraph from '@editorjs/paragraph';

const termsTools = {
  underline: Underline,
  header: Header,
  paragraph: Paragraph,
  list: List,
  table: {
    class: Table,
    config: {
      rows: 2,
      cols: 2,
    },
  },
};

window.initEditorReadOnly = ({ holderId = 'editorjs-view', data = {}}) => {
  new EditorJS({
    holder: holderId,
    readOnly: true,
    data,
    tools: termsTools,
  });
};